
import React, { useEffect } from 'react';

import Table from "./partials/Table";
import RewardCalcAutoToggle from "../../../components/RewardCalcAutoToggle";

export default () => {

  useEffect(() => {
    document.title = "Kết quả Max3D Pro"
  }, []);

  return (
    <>
      <RewardCalcAutoToggle gameId="max3dpro" gameName="Max3D Pro" />

      <Table />
    </>
  );
};
